import { FormatStringByWordLength, DoArraysOverlap, Split, Join } from "../../../shared/scripts/array-functions";

export interface CTMSAddressEntity {
    Id: number;
    AddressTypeId: number;
    Address: string;
}

export interface CTMSUserEntity {
    Id: number;
    PortalId: number;
    Name: string;
    Email: string;
    PhoneNumber: string;
    RoleId: number;
    IsArchived: boolean;
}

export interface CTMSUserSiteEntity {
    Id: number;
    CTMSUserId: number;
    CTMSUser: CTMSUserEntity;
    CTMSSiteId: number;
    RoleId: number;
}

export interface CTMSStudyEntity {
    Id: number;
    Name: string;
}

export interface CTMSSiteStudyEntity {
    Id: number;
    CTMSSiteId: number;
    CTMSStudyId: number;
    CTMSStudy: CTMSStudyEntity;
    CurrentStatusId: number;
    CurrentStatusDate: string;
    IsArchived: boolean;
}

export class SiteLevelSummaryDto {
    Id: number;
    SiteNumber: number;
    SiteName: string;
    CTMSStudy: CTMSStudyEntity[];
    StudyList: string[];
    UserNames: string[];

    constructor() { }

    initialize(): void {
        this.StudyList = this.CTMSStudy?.map(study => study.Name) ?? [];
    }

    matchesFilter(study: any, siteManagers: any): boolean {
        
        if (!DoArraysOverlap(study, this.StudyList)) { return false; }
        //if (!DoArraysOverlap(siteManagers, this.UserNames)) { return false; }
        let values: string[] = [];
        if (this.UserNames.length > 0) { values.push(...this.UserNames); }
        else { values.push("Unassigned"); }
        if (!DoArraysOverlap(siteManagers, values)) { return false; }

        return true;
    }
}

export class SiteEntity {
    Id: number;
    SiteNumber: number;
    SiteName: string;
    SubcontractNumber: string;
    PONumber: string;
    VendorNumber: string;
    ChargeCode: string;
    Address: CTMSAddressEntity;
    ContractName: string;
    IsArchived: boolean;
    CTMSUserSites: CTMSUserSiteEntity[];
    CTMSSiteStudies: CTMSSiteStudyEntity[];

    CTMSStudy: CTMSStudyEntity[];
    CTMSStudies: CTMSStudyEntity[];
    StudyList: string[];
    UserNames: string[];
    //get CTMSStudies(): CTMSStudyEntity[] {
    //    return this.CTMSSiteStudies?.map(ss => ss.CTMSStudy) ?? [];
    //}

    constructor() { }

    initialize(): void {
        this.StudyList = this.CTMSStudy?.map(study => study.Name) ?? [];
    }

    matchesFilter(study: any, siteManagers: any): boolean {

        if (!DoArraysOverlap(study, this.StudyList)) { return false; }
        //if (!DoArraysOverlap(siteManagers, this.UserNames)) { return false; }
        let values: string[] = [];
        if (this.UserNames.length > 0) { values.push(...this.UserNames); }
        else { values.push("Unassigned"); }
        if (!DoArraysOverlap(siteManagers, values)) { return false; }

        return true;
    }
}